import useObservabilityConfig from 'src/public/useObservabilityConfig';

import type {ProjectName} from 'src/internal/common/types';

/**
 * @see https://sail.stripe.me/apis/observability/useProject
 */
export default function useProject(): ProjectName {
  return useObservabilityConfig().project;
}
